import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Preset from '../assets/themes/preset';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { MessageService, ConfirmationService } from 'primeng/api';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';

const PRIMEUI_LICENSE =
  'eyJpZCI6IjI2NjA3ODA1LTZhMWYtNDE0Ny05NTY5LTI0NjRkMTg2MmVkYSIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODc0ODg1NzIsImV4cCI6MTgxOTAyNDU3Mn0.lY9KT2XwljZ1Qcn5YU3g_aEeNhCuvHiqPPwGIQVsOoAag3VgGNCDEIuAwO4Cpl71HHtevol3Zh-bqX3MziW9Cw';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    providePrimeNG({
      license: PRIMEUI_LICENSE,
      theme: {
        preset: Preset,
        options: {
          darkModeSelector: '.never-dark-mode',
          cssLayer: { name: 'primeng', order: 'theme, base, primeng' },
        },
      },
    }),
    provideHttpClient(withXhr(), withInterceptors([ErrorInterceptor, AuthInterceptor])),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    MessageService,
    ConfirmationService,
  ]
};
